import { useConfigParams } from "@/hooks/use-config-params"
import { useMutationState } from "@/hooks/use-mutation-state"
import { AuthType, TAuthType } from "@/lib/auth-type"
import { Ok } from "@pacote/result"
import { OkLoginResponse, TloginResponse } from "../post-login"
import { TOAuthLoginResponse } from "../post-login-oauth"
import { TSsoLoginResponse } from "../post-login-sso"

export function useLoginData() {
  const { authType } = useConfigParams()

  const dataEndpoint = getDataEndpoint(authType)

  const loginData = useMutationState<
    | OkLoginResponse
    | Ok<TSsoLoginResponse>
    | Ok<TOAuthLoginResponse>
    | undefined
  >(dataEndpoint).data?.value

  return getLoginData(authType, loginData)
}

function getDataEndpoint(authType: TAuthType) {
  switch (authType) {
    case AuthType.OAuth:
      return "/authentication-ms/v1/oauth/login"
    case AuthType.Sso:
      return "/authentication-ms/v1/sso/login"
    default:
      return "/authentication-ms/v1/login"
  }
}

function getLoginData(
  authType: TAuthType,
  loginData?: TloginResponse | TOAuthLoginResponse | TSsoLoginResponse,
):
  | ((TloginResponse | TOAuthLoginResponse | TSsoLoginResponse) & {
      token?: string
    })
  | undefined {
  // for SSO and OAuth, the token is called "jwt" in the back-end, but has the same use.
  // To avoid having to discriminate everywhere, we just use the value of "jwt" as the "token"
  // if the "token" is not present.
  if (
    (authType === "sso" || authType === "oauth") &&
    loginData &&
    (!("token" in loginData) || loginData.token == null) &&
    "jwt" in loginData &&
    typeof loginData.jwt === "string"
  ) {
    return { ...loginData, token: loginData.jwt }
  } else {
    return loginData
  }
}
